import Cookies from "js-cookie";

const setCookie = (cookiename, usrin) => {
    Cookies.set(cookiename, usrin, {
        expires: 1,
    });
};
export default setCookie;
